/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LabelState,
  LabelState$inboundSchema,
  LabelState$Outbound,
  LabelState$outboundSchema,
} from "./labelstate.js";

/**
 * Defines a label that is overlaid on top of an animatic.
 */
export type AnimaticLabel = {
  /**
   * The name of the label. This is used to identify the label in the client, ideally it should be unique.
   */
  name: string;
  /**
   * The states of the label.
   */
  states: Array<LabelState>;
};

/** @internal */
export const AnimaticLabel$inboundSchema: z.ZodType<
  AnimaticLabel,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: types.string(),
  states: z.array(LabelState$inboundSchema),
});
/** @internal */
export type AnimaticLabel$Outbound = {
  name: string;
  states: Array<LabelState$Outbound>;
};

/** @internal */
export const AnimaticLabel$outboundSchema: z.ZodType<
  AnimaticLabel$Outbound,
  z.ZodTypeDef,
  AnimaticLabel
> = z.object({
  name: z.string(),
  states: z.array(LabelState$outboundSchema),
});

export function animaticLabelToJSON(animaticLabel: AnimaticLabel): string {
  return JSON.stringify(AnimaticLabel$outboundSchema.parse(animaticLabel));
}
export function animaticLabelFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticLabel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticLabel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticLabel' from JSON`,
  );
}
